import React from "react";
import { useTranslation } from "react-i18next";
import { Stack, Box, Card, CardContent, Typography } from "@mui/material";
import AccessToggleButton from "../Inputs/AccessToggleButton";
import AccessButton from "../Buttons/AccessButton";

const EmployeeCard = ({
  firstName,
  lastName,
  department,
  userName,
  userId,
  email,
  token,
  applicationId,
  handleAlert,
  expiryDate,
  startDate,
  history,
  handleRender,
  daysLeft,
}) => {
  const { t } = useTranslation();
  const textGreen = { color: "green", fontWeight: "bold" };
  const textRed = { color: "red", fontWeight: "bold" };
  const textYellow = { color: "#ADAD03", fontWeight: "bold" };

  const expiryTimestamp =
    typeof expiryDate !== Number ? Number(expiryDate) : expiryDate;
  const startTimestamp =
    typeof startDate !== Number ? Number(startDate) : startDate;
  const expiry = new Date(expiryTimestamp);
  const start = new Date(startTimestamp);

  const expiryTextClass = (days) => {
    if (days <= 3) return textRed;
    if (days <= 7) return textYellow;
    if (days <= 14) return textGreen;
  };

  return (
    <Card
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        overflow: "hidden",
        p: 2,
      }}
    >
      <Stack
        spacing={2}
        direction={{ sm: "column", md: "column" }}
        sx={{ flex: 1 }}
      >
        <Box sx={{ flex: 1 }}>
          <CardContent
            sx={{
              flex: "1 0 auto",
              overflow: "hidden",
              paddingBottom: "0px !important",
            }}
          >
            <Typography variant="body1">
              <b>{`${firstName} ${lastName}`}</b>
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: { xs: "normal", md: "normal" } }}
            >
              <b>{t("employeeCard.department")}:</b> {department}
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: { xs: "normal", md: "normal" } }}
            >
              <b>{t("employeeCard.userName")}:</b> {userName}
            </Typography>
            <Typography
              variant="body2"
              sx={{ whiteSpace: { xs: "normal", md: "normal" } }}
            >
              <b>{t("employeeCard.email")}:</b> {email}
            </Typography>
            {history && (
              <>
                <Typography variant="body2">
                  <b>{t("employeeCard.from")}: </b>
                  {start.toLocaleDateString("de-DE")}
                </Typography>
                <Typography variant="body2">
                  <b>{t("employeeCard.to")}: </b>
                  {expiry.toLocaleDateString("de-DE")}
                </Typography>
              </>
            )}
            {!history && expiryDate && (
              <Box sx={{ display: "flex" }}>
                <Typography variant="body2" sx={{ paddingRight: 1 }}>
                  <b>{t("employeeCard.expiry")}: </b>
                  {expiry.toLocaleDateString("de-DE")}
                </Typography>
                {daysLeft >= 0 ? (
                  <Typography variant="body2" sx={expiryTextClass(daysLeft)}>
                    ({daysLeft} {t("employeeCard.daysRemaining")})
                  </Typography>
                ) : (
                  <Typography variant="body2" sx={textRed}>
                    {t("employeeCard.expired")}
                  </Typography>
                )}
              </Box>
            )}
          </CardContent>
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: "0px",
          }}
        >
          {!history &&
            (expiryDate ? (
              <AccessToggleButton
                userName={userName}
                applicationId={applicationId}
                token={token}
                handleAlert={handleAlert}
                handleRender={handleRender}
              />
            ) : (
              <AccessButton
                userId={userId}
                token={token}
                applicationId={applicationId}
                handleAlert={handleAlert}
                handleRender={handleRender}
              />
            ))}
        </Box>
      </Stack>
    </Card>
  );
};

export default EmployeeCard;
